// extracted by mini-css-extract-plugin
export default {"Description":"TextFieldConfig_Description__u4PN0"};